import { FETCH_HISTORY_SUCCESS } from './types'

const historyReducer = (state, action) => {
  switch (action.type) {
    case FETCH_HISTORY_SUCCESS:
      return {
        ...state,
        history: [...state.history, ...action.payload.projects],
        projectsCount: action.payload.projects_count,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        }
      }
    default:
      return state
  }
}

export { historyReducer }
